import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion'; // Import framer-motion
import { HeroData, OurValue, TransformIdea, Partner } from '../../../constants/constants';
import './hero.css';
import { WhyChooseUs, Heros } from '../../../assets/images/index';
const Hero = () => {
  const [counts, setCounts] = useState({
    labour: 300,
    completedprojects: 200,
    years: 3,
    happyclients: 120,
  });

  useEffect(() => {
    const intervals = [
      { name: 'labour', target: 400, interval: 50 },
      { name: 'completedprojects', target: 300, interval: 20 },
      { name: 'years', target: 15, interval: 5000 },
      { name: 'happyclients', target: 200, interval: 50 },
    ];

    const timers = intervals.map((item) => {
      return setInterval(() => {
        setCounts((prevCounts) => {
          if (prevCounts[item.name] < item.target) {
            return { ...prevCounts, [item.name]: prevCounts[item.name] + 1 };
          }
          return prevCounts;
        });
      }, item.interval);
    });

    return () => timers.forEach(clearInterval);
  }, []);

  

  const splitTextArray = (text) => {
    return text.split("").map((char, index) => (
      <motion.span
        key={index}
        initial={{ opacity: 0, y: -10 }} // Start slightly above
        animate={{ opacity: 1, y: 0 }}   // Animate to normal position
        transition={{
          delay: index * 0.05, // Faster staggered effect for characters
          duration: 0.3,
          ease: "easeOut",
        }}
        className="inline-block"
      >
        {char === " " ? "\u00A0" : char} {/* Preserve spaces */}
      </motion.span>
    ));
  };
  
  return (
    <div>
      {/* Initial Section */}
      <motion.div
        className="bg-cover bg-center bg-no-repeat w-full h-screen min-h-[300px] backdrop-blur-sm"
        style={{
          backgroundImage: `url(${Heros})`,
          backgroundSize: 'cover', // Cover the entire container (ensure the image always covers the space)
          backgroundPosition: 'center', // Keep the image centered
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, y: 0 }} // Slide in from the top when in view
        viewport={{ once: true }} // Triggers animation when in view
      >
        <div className="flex justify-center items-center my-auto flex-col gap-[15px] fontText">
          <h2 className="font-semibold text-[65px] text-[#ffffff] mt-[100px] max-md:text-[42px]"> 
            {splitTextArray('Welcome to the')}
          </h2>
          <h2 className="font-semibold text-[65px] text-[#ffffff] max-md:text-[42px] max-md:max-w-[300px] max-md:text-center">
            {splitTextArray('Shree Dattguru Enterprise')}
          </h2>
        </div>
      </motion.div>


      {/* Hero Data Section */}
      <motion.div
        className="container flex flex-row justify-center max-md:items-center max-md:flex-col items-end gap-[50px] py-[100px]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 3, delay: 1 }}
        whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
        viewport={{ once: true }}
      >
        {HeroData.map((item, index) => (
          <div key={index} className="flex flex-col items-center">
            <h4 className="fontText text-[32px] font-semibold">
              {counts[item.name.toLowerCase().replace(/ /g, '')]} +
            </h4>
            <h5 className="fontText text-[24px] font-semibold">
              {item.name}
            </h5>
          </div>
        ))}
      </motion.div>

      {/* Why Choose Us Section */}
      <motion.div
        className="container max:md:items-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2, delay: 1.2 }}
        whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
        viewport={{ once: true }}
      >
        {/* <h2 className="items-center text-[42px] font-semibold fontText text-center mb-[40px] max-md:text-center max-md:text-[42px]"> */}
        <motion.h2 className='items-center text-[42px] font-semibold fontText text-center mb-[40px] max-md:text-center max-md:text-[42px] px-[18px]' whileInView={{ opacity: 1 }} initial={{ opacity: 0 }}>
            {splitTextArray('Why Choose Shree Dattguru Enterprise?')}
          </motion.h2>
        {/* </h2> */}
        <div className="container w-[100%] flex flex-row items-center justify-center max-md:flex-col gap-[40px]">
          <div className="rounded-[10px] w-full flex justify-center items-center mx-0 my-auto">
            <img
              src={WhyChooseUs}
              alt=""
              className="rounded-[10px] max-w-[553px] max-md:max-w-[300px] max-md:max-h-[188px] max-h-[348px]"
            />
          </div>
          <div className="max-w-[400px] font-normal text-[18px] fontText max-md:text-center max-md:px-[20px]">
            <h4>
              {splitTextArray('At Shree Dattguru Enterprise, with over 15 years + of experience, we are committed to delivering quality and transparency in every project. We enhance project speed and efficiency while reducing manpower dependency. This approach not only ensures high-quality outcomes but also helps us build long-lasting relationships with clients, consultants, and design teams. Trust in us to consistently exceed expectations and deliver successful projects.')}
            </h4>
          </div>
        </div>
      </motion.div>

      {/* Value Section */}
      <motion.div
        className="container py-[100px]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 4, delay: 3 }}
        whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
        viewport={{ once: true }}
      >
        <h4 className="text-center text-[42px] fontText font-semibold mb-[30px] max-md:text-[32px]">OUR VALUES</h4>
        <div>
          <div className="flex flex-wrap max-md:flex-col items-center justify-center gap-[30px] max-md:gap-[40px]">
            {OurValue.map((item, index) => (
              <div
                key={index}
                className="w-[340px] h-[345px] max-md:w-[300px] max-md:px-[20px] bg-[#F2F0F0] flex flex-col justify-center items-center rounded-[10px] shadow-[#00000040] transform transition-all duration-300 hover:scale-105"
              >
                <div className="mt-[20px]">
                  <img src={item.icon} alt={item.title} className="w-[104px] h-[104px]" />
                </div>
                <h4 className="text-[20px] font-semibold TextFont mb-[13px]">{item.title}</h4>
                <h6 className="max-w-[248px] font-normal TextFont text-[16px] text-center">{item.description}</h6>
              </div>
            ))}
          </div>
        </div>
      </motion.div>

      {/* Transforming Ideas Section */}
      <motion.div
        className="container pb-[100px]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 4, delay: 4 }}
        whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
        viewport={{ once: true }}
      >
        <h4 className="text-[42px] fontText font-semibold mb-[40px] max-md:text-[42px] text-center flex justify-center items-center">
          TRANSFORMING IDEAS INTO STRUCTURE
        </h4>
        <div className="flex flex-wrap max-md:flex-col items-center justify-center gap-[30px] max-md:gap-[40px]">
          {TransformIdea.map((item, index) => (
            <div key={index} className="max-md:px-[20px] my-[10px] mx-[10px] flex flex-col justify-center items-center">
              <div className="transform transition-all duration-300 hover:scale-105">
                <img src={item.icon} alt={item.title} className="w-[300px] rounded-[10px] h-[247px]" />
              </div>
              <h4 className="text-[24px] font-semibold pt-[22px]">{item.title}</h4>
            </div>
          ))}
        </div>
        <a
          href="/services"
          className="w-[200px] text-[18px] font-bold bg-[#F2F0F0] h-[52px] items-center transform transition-all duration-300 hover:scale-105 text-center rounded-[30px] cursor-pointer flex justify-center mb-0 mt-[40px] mx-auto"
        >
          View more
        </a>

        {/* Partners Section */}
        <motion.div
          className="container py-[100px]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 5, delay: 5 }}
          whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
          viewport={{ once: true }}
        >
          <h4 className="text-center text-[42px] fontText font-semibold mb-[40px] max-md:text-[42px]">
            OUR PARTNERS
          </h4>
          <div className="flex flex-row items-center justify-center flex-wrap max-md:flex-col gap-[30px]">
            {Partner.map((img, index) => (
              <div key={index}>
                <img src={img.icon} alt="" />
              </div>
            ))}
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Hero;
